import { ServerErrorField } from "@/components/server-error-field/ServerErrorField.tsx";
import { OfferEditStepDetails } from "@/pages/recruit/offers/components/OfferEditStepDetails.tsx";
import { OfferEditStepPreview } from "@/pages/recruit/offers/components/OfferEditStepPreview.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { ApiApplicantShort } from "@/types/recruit/applicant.types.ts";
import { ApiOfferRequest, OfferEditModalContext, OfferSteps } from "@/types/recruit/offer.types.ts";
import { Modal, ModalProps, Skeleton, Stack } from "@skailer-com/uikit";
import { useOfferEditHook } from "./use-offer-edit.hook.tsx";

export interface OfferEditModalProps extends ModalProps {
  offerRequest?: ApiOfferRequest;
  candidateId?: number;
  applicant?: ApiApplicantShort;
  employeeId?: number;
  jobId?: number;
  onSave?: () => void;
}

export function OfferEditModal({
  candidateId,
  applicant,
  employeeId,
  offerRequest,
  jobId,
  onSave,
  ...props
}: OfferEditModalProps) {
  const { id } = props;
  const { data: me } = useEmployeeMe();

  const {
    modalTitle,
    modalCaption,
    currentStep,
    onBack,
    actionsButton,
    formHook,
    isConfigPending,
    sections,
    formFields,
    handleUpdateConfig,
    offerConfig,
  } = useOfferEditHook({
    id,
    candidateId,
    applicant,
    offerRequest,
    jobId,
    onSave,
  });

  const context = {
    applicant,
    offerRequest,
    formHook,
    sections,
    formFields,
    employeeId: employeeId ?? me?.id,
    handleUpdateConfig,
    offerConfig,
  };

  return (
    <Modal
      {...props}
      title={modalTitle}
      caption={modalCaption}
      withCloser
      size={"lg"}
      variant={"middle"}
      layout="stretch"
      actions={<Stack gap="sm">{actionsButton}</Stack>}
      onBack={onBack()}
    >
      {isConfigPending ? (
        <Stack gap="md">
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </Stack>
      ) : (
        <OfferEditModalContext.Provider value={context}>
          <div className={currentStep === OfferSteps.details ? undefined : "hidden"}>
            <OfferEditStepDetails />
          </div>
          {currentStep == OfferSteps.preview && <OfferEditStepPreview />}
          <ServerErrorField errors={formHook.formState.errors} />
        </OfferEditModalContext.Provider>
      )}
    </Modal>
  );
}
